import React, { useContext } from "react";
import Modal from "react-bootstrap/Modal";
import { Button, Form } from "reactstrap";
import { FaTimes } from "react-icons/fa";
import InputField from "./InputFieldV1";
import SelectInputField from "./SelectInputFieldV1";
import { SettingGeneralContext, SettingGeneralProvider } from "../../context/settingGeneralContext";

export default function ModalAddReusable({
    isOpen,
    isClose,
    handleSubmit,
    handleChange,
    fields = [],
    title,
    onSoapDoctorClick,
    showDoctorDropdown,
    showButtonApproveDoctor,
    approvalStatus,
    handleSendApproval,
}) {
    return (
        <SettingGeneralProvider>
            <ModalAddReusableContent
                isOpen={isOpen}
                isClose={isClose}
                handleSubmit={handleSubmit}
                handleChange={handleChange}
                fields={fields}
                onSoapDoctorClick={onSoapDoctorClick}
                showDoctorDropdown={showDoctorDropdown}
                showButtonApproveDoctor={showButtonApproveDoctor}
                approvalStatus={approvalStatus}
                handleSendApproval={handleSendApproval}
                title={title}
            />
        </SettingGeneralProvider>
    );
}

function ModalAddReusableContent({
    isOpen,
    isClose,
    handleSubmit,
    handleChange,
    fields,
    title,
    onSoapDoctorClick,
    showDoctorDropdown,
    handleSendApproval,
    approvalStatus,
}) {
    const { state } = useContext(SettingGeneralContext);
    const appSidebarColor1 = state?.showTheme?.app_sidebar_color_1 ?? "#29B8FF";
    const buttonColor = state?.showTheme?.app_sidebar_color_2 ?? "#3d64ff";

    return (
        <Modal show={isOpen} onHide={isClose} aria-labelledby="contained-modal-title-vcenter" centered style={{ fontFamily: "sans-serif", border: "none" }}>
            <div style={{ width: "100%", display: "flex", padding: "10px 0px", backgroundColor: "#29B8FF" }}>
                <div style={{ flex: "92%", fontSize: "20px", display: "flex", alignItems: "center", paddingLeft: "10px", color: "white", fontWeight: "600" }}>
                    Soap Patient ||
                </div>
                <div style={{ flex: "8%", fontSize: "30px", display: "flex", alignItems: "center", justifyContent: "center", color: "white" }}>
                    <FaTimes onClick={isClose} style={{ cursor: "pointer" }} />
                </div>
            </div>

            <Modal.Body>
                <Form onSubmit={handleSubmit} className="mt-3">
                    {fields.map((field, index) => {
                        if (field.type === "select") {
                            return (
                                <>
                                    <SelectInputField
                                        key={index}
                                        label={field.label}
                                        name={field.name}
                                        value={field.value}
                                        onChange={handleChange}
                                        options={field.options || []}
                                        disabled={field.disabled}
                                    />
                                </>
                            );

                        } else if (field.type === "date-picker") {
                            return (
                                <div className="mt-2 is-flex">
                                    <div className="is-flex is-align-items-center" style={{ flex: "5%" }}>
                                        <span>Tanggal Lahir</span>
                                        <span className="has-text-danger" style={{ fontSize: "18px" }}>*</span>
                                    </div>
                                    <div className="is-flex is-flex-direction-column" style={{ flex: "60%" }}>
                                        {/* Day, Month, Year Dropdowns */}
                                        <div className="field is-grouped is-fullwidth">
                                            <div className="control is-expanded">
                                                <div className="select is-fullwidth">
                                                    <select
                                                        className="form-control"
                                                        name="day_birth"
                                                        value={field.value.day}
                                                        onChange={handleChange}
                                                    >
                                                        <option value="" hidden>Day</option>
                                                        {Array.from({ length: 31 }, (_, i) => i + 1).map(day => (
                                                            <option key={day} value={day.toString().padStart(2, '0')}>
                                                                {day}
                                                            </option>
                                                        ))}
                                                    </select>
                                                </div>
                                            </div>
                                            <div className="control is-expanded">
                                                <div className="select is-fullwidth">
                                                    <select
                                                        className="form-control"
                                                        name="month_birth"
                                                        value={field.value.month}
                                                        onChange={handleChange}
                                                    >
                                                        <option value="" hidden>Month</option>
                                                        {[
                                                            "Januari", "Februari", "Maret", "April", "Mei", "Juni", "Juli",
                                                            "Agustus", "September", "Oktober", "November", "Desember"
                                                        ].map((month, i) => (
                                                            <option key={i} value={(i + 1).toString().padStart(2, '0')}>
                                                                {month}
                                                            </option>
                                                        ))}
                                                    </select>
                                                </div>
                                            </div>

                                            <div className="control is-expanded">
                                                <div className="select is-fullwidth">
                                                    <select
                                                        className="form-control"
                                                        name="year_birth"
                                                        value={field.value.year}
                                                        onChange={handleChange}
                                                    >
                                                        <option value="" hidden>Year</option>
                                                        {Array.from({ length: 84 }, (_, i) => 1940 + i).map(year => (
                                                            <option key={year} value={year}>
                                                                {year}
                                                            </option>
                                                        ))}
                                                    </select>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            );
                        } else {
                            return (
                                <>
                                    <InputField
                                        key={index}
                                        label={field.label}
                                        name={field.name}
                                        value={field.value}
                                        onChange={handleChange}
                                        type={field.type || "text"}
                                        autoFocus={field.autoFocus}
                                        microphone={field.microphone}
                                        disabled={field.disabled}
                                        onClick={field.onClick}
                                    />
                                </>
                            );
                        }
                    })}
                    <div className="mt-1" style={{ display: "flex", justifyContent: "center" }}>
                        <div style={{ width: "80%" }}>
                            <div style={{ padding: "0px 0px", marginTop: "20px", display: "flex", justifyContent: "end" }}>
                                <div>
                                    <Button className="mt-2" type="submit" color='primary' block style={{ padding: "8px 10px", fontSize: "12px", borderRadius: "5px" }}>
                                        Simpan
                                    </Button>
                                </div>
                            </div>
                        </div>
                    </div>
                </Form>
            </Modal.Body>
        </Modal >
    );
}
